import React from 'react'
import PageTitle from '../page-title'
import SelectItem from '../select-item'
import Spacer from '../spacer'
import css from './style.css'
import PrimaryMetalTypePanel from './primary-metal-type-panel'
import PrimaryDiamondPanel from './primary-diamond-panel'
import MultiStonePanel from './multi-stone-panel'
import CentreHaloPanel from './centre-halo-panel'
import ShankPanel from './shank-panel'
import ShankTopDiamondPanel from './shank-top-diamond-panel'
import ShankSideDiamondPanel from './shank-side-diamond-panel'
import ProngPanel from './prong-panel'
import PendantChainPanel from './pendant-chain-panel'
import StockItemPanel from './stock-item-panel'
import AdditionalDiamondContainer from './additional-diamond-panel/additional-diamonds-container'
import BailPanel from './bail-panel'
import RingSizePanel from './ring-size-panel'
import BasketTypePanel from './basket-type-panel'
import AdditionalOptionPanel from './additional-option-panel'
import AdditionalChargePanel from './additional-charge-panel'

import _ from 'lodash'

const JewelrySearchFilters = (props) => {
  const onChangeVal = (key, val) => {
    if (!props.onChangeVal) {
      return
    }
    if (_.has(val, 'target')) {
      // handle the value for text or number input fields
      onChangeVal(key, val.target.value)
    } else {
      // handle the value for SelectItem field
      props.onChangeVal(key, val)
    }
    // cascade select
    // 1. when lucida basket is selected for the prong, cathedral shoulders must be selected
    if (key === 'basket_style' && val === 'lucida') {
      props.onChangeVal('cathedral_shoulders', 'yes')
    }
  }

  return (
    <div className={css.jewelryFilters}>
      <PageTitle title='Jewellery'>Create something special</PageTitle>

      <SelectItem
        id='jewelry_type'
        label='Product Type'
        labelId='product'
        options={[
          {value: 'EngagementRing', label: 'Engagement Ring'},
          {value: 'FemaleWeddingBand', label: "Women's Band"},
          {value: 'MaleWeddingBand', label: "Men's Band"},
          {value: 'StudEarring', label: 'Stud Earrings'},
          {value: 'Pendant', label: 'Pendant'},
          {value: 'StockItem', label: 'Stock Item'}
        ]}
        value={props.jewelry_type}
        onChange={onChangeVal.bind(this, 'jewelry_type')}
      />

      <PrimaryMetalTypePanel {...props} onChangeVal={onChangeVal} />

      <RingSizePanel {...props} onChangeVal={onChangeVal} />

      <PrimaryDiamondPanel {...props} onChangeVal={onChangeVal} />

      <BasketTypePanel {...props} onChangeVal={onChangeVal} />

      <BailPanel {...props} onChangeVal={onChangeVal} />

      <MultiStonePanel
        {...props}
        onChangeVal={onChangeVal}
        defaultHaloWidthOptions={props.defaultHaloWidthOptions}
      />

      <CentreHaloPanel
        {...props}
        onChangeVal={onChangeVal}
        defaultHaloWidthOptions={props.defaultHaloWidthOptions}
      />

      <ShankPanel
        {...props}
        onChangeVal={onChangeVal}
        verticalShankThicknessOptions={props.verticalShankThicknessOptions}
        defaultShankWidthOptions={props.defaultShankWidthOptions}
      />

      <ShankTopDiamondPanel {...props} onChangeVal={onChangeVal} />

      <ShankSideDiamondPanel {...props} onChangeVal={onChangeVal} />

      <ProngPanel {...props} onChangeVal={onChangeVal} />

      <StockItemPanel {...props} onChangeVal={onChangeVal} sessionCurrency={props.sessionCurrency} />

      <AdditionalDiamondContainer />

      <PendantChainPanel {...props} onChangeVal={onChangeVal} />

      <AdditionalOptionPanel {...props} onChangeVal={onChangeVal} />

      <Spacer xs />

      <AdditionalChargePanel {...props} onChangeVal={onChangeVal} />

      <Spacer lg />
    </div>
  )
}

export default JewelrySearchFilters



// WEBPACK FOOTER //
// ./src/components/jewelry-search-filters/index.js